import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import './Auth.css';
import Header from '../components/Header';

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    company: '',
    plan: 'basic'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (!formData.email || !formData.password || !formData.name) {
        setError('Please fill in all required fields');
        setLoading(false);
        return;
      }

      const response = await authAPI.signup(formData.email, formData.name, formData.password);
      
      // Store authentication data
      localStorage.setItem('token', response.token);
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userEmail', response.email);
      localStorage.setItem('userName', response.name);
      localStorage.setItem('userPlan', response.plan);
      localStorage.setItem('userId', response.id.toString());
      
      navigate('/dashboard');
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Signup failed. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Header />
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Create Your Account</h2>
          <p>Start your free trial today</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Doe"
              required
            />
          </div>
          <div className="form-group">
            <label>Company Name</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Your Company"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@company.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              required
              minLength="8"
            />
            <small className="form-hint">Must be at least 8 characters</small>
          </div>
          <div className="form-group">
            <label>Choose Plan</label>
            <select name="plan" value={formData.plan} onChange={handleChange} className="form-select">
            <option value="free">Free – ₹0 / month</option>
            <option value="basic">Basic – ₹199 / month</option>
            <option value="pro">Pro – ₹499 / month</option>
            <option value="premium">Premium – ₹999 / month</option>
            <option value="enterprise">Enterprise – Custom Pricing</option>
            </select>
            <small className="form-hint">You can upgrade or downgrade anytime</small>
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
        <div className="auth-footer">
          <p>
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default Signup;
